<template>
  <eg-b-form class="d-flex flex-column flex-gap-1">
    <eg-form-group :label="$t('common.name')" class="m-0">
      {{ sourceMaterial.title }}
    </eg-form-group>

    <eg-form-group
      :label="$t('materials.createEditModal.writingPrompt')"
      class="m-0"
    >
      <div v-if="sourceMaterial.tdaInstructions" class="preview-text">
        {{ sourceMaterial.tdaInstructions }}
      </div>
      <div v-else class="empty-value">{{ $t("common.empty") }}</div>
    </eg-form-group>

    <eg-form-group
      :label="$t('materials.createEditModal.referenceMaterials')"
      class="m-0"
    >
      <div v-if="sourceMaterial.tdaSources.length">
        <ul
          v-for="source in sourceMaterial.tdaSources"
          :key="source.name"
          class="d-flex flex-column"
        >
          <li>{{ source.name }}</li>
        </ul>
      </div>
      <div v-else class="empty-value">{{ $t("common.noFilesUploaded") }}</div>
    </eg-form-group>
  </eg-b-form>
</template>

<script>
export default {
  name: "SourceMaterialPreviewForm",
  props: {
    sourceMaterial: { type: Object, default: null },
  },
};
</script>

<style lang="scss" scoped>
.label {
  color: var(--color-text-neutral-on-white);
  font-size: var(--typography-font-size-fs-400);
  font-weight: var(--typography-font-weight-fw-600);
}

.empty-value {
  color: var(--color-text-secondary);
}

.preview-text {
  white-space: pre-line;
}
</style>
